/**
 * DirectCosts — Batch #14.333 : frais directs d'un dossier (enquête de crédit, sous-traitance…) ajoutés au coût interne de la rentabilité.
 */
import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { Btn, errMsg, inputCls, money } from "../comptabilite/_shared";

const today = () => new Date().toISOString().slice(0, 10);

export default function DirectCosts({ masterId, items, onChanged }) {
  const [f, setF] = useState({ date: today(), label: "", amount: "" });
  const [busy, setBusy] = useState(false);
  const add = async () => {
    setBusy(true);
    try {
      await api.post(`/admin/profitability/direct-costs/${masterId}`, { ...f, amount: Number(f.amount) });
      toast.success("Frais direct ajouté"); setF({ date: today(), label: "", amount: "" }); onChanged();
    } catch (e) { toast.error(errMsg(e, "Ajout impossible")); } finally { setBusy(false); }
  };
  const del = async (c) => {
    if (!window.confirm(`Retirer « ${c.label} » (${money(c.amount)}) ?`)) return;
    try { await api.delete(`/admin/profitability/direct-costs/${masterId}/${c.id}`); toast.success("Frais retiré"); onChanged(); }
    catch (e) { toast.error(errMsg(e, "Suppression impossible")); }
  };
  return (
    <div className="mt-2 border-t border-slate-200 pt-2" data-testid={`direct-costs-${masterId}`}>
      <div className="font-medium text-slate-700 mb-1">Frais directs du dossier {items.length ? `· ${money(items.reduce((a, c) => a + c.amount, 0))}` : ""}</div>
      {items.length > 0 && (
        <ul className="space-y-0.5 mb-2">
          {items.map((c) => (
            <li key={c.id} className="flex items-center gap-2" data-testid={`direct-cost-${c.id}`}>
              <span className="font-mono text-slate-500">{c.date}</span><span className="flex-1 truncate">{c.label}</span><span className="font-mono">{money(c.amount)}</span>
              <button type="button" onClick={(e) => { e.stopPropagation(); del(c); }} className="text-slate-400 hover:text-rose-700 p-0.5" title="Retirer" data-testid={`direct-cost-delete-${c.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </li>
          ))}
        </ul>
      )}
      <div className="flex flex-wrap items-end gap-2" onClick={(e) => e.stopPropagation()}>
        <div className="w-40"><input type="date" className={inputCls} value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="direct-cost-date" /></div>
        <div className="flex-1 min-w-[12rem]"><input className={inputCls} placeholder="Libellé (ex. Enquête de crédit — Equifax)" value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} data-testid="direct-cost-label" /></div>
        <div className="w-32"><input type="number" step="0.01" min="0" className={`${inputCls} font-mono text-right`} placeholder="Montant" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="direct-cost-amount" /></div>
        <Btn tone="slate" icon={Plus} busy={busy} disabled={!f.label.trim() || !(Number(f.amount) > 0) || !f.date} onClick={add} testId="direct-cost-add">Ajouter</Btn>
      </div>
    </div>
  );
}
